import Text from "@frog/source/views/Text.view.js"
import NineCut from "@frog/source/views/NineCut.view.js"

export default function Dialogue(stage) {
    if(stage == undefined
    || stage.dialogue == undefined) {
        return
    }
    if(stage.dialogue.type == "popup") {
        return {
            "key": "Dialogue",
            "width": "100%",
            "height": "100%",
            // "anchor": {"x": "50%", "y": "50%"},
            // "position": {"x": "50%", "y": "50%"},
            "_": [
                {
                    "position": {
                        "x": ((32/2)-(10/2)) * 16,
                        "y": ((18/2)-1) * 16,
                    },
                    "width": 20 * 16,
                    "height": 4 * 16,
                    "_": [
                        NineCut({
                            "width": 20,
                            "height": 4,
                        })
                    ]
                },
                {
                    // "position": {
                    //     "x": ((32/2)-(10/2)) * 16 + 6,
                    //     "y": ((18/2)-2) * 16 + 3,
                    // },
                    "anchor": {"x": "50%", "y": "50%"},
                    "position": {"x": "50%", "y": "50%"},
                    "_": stage.dialogue.text.split("<br>").filter((text) => text != "").map((text, index) => {
                        return {
                            // "position": {
                            //     "y": index * (11 + 4)
                            // },
                            "_": [
                                Text({
                                    "text": text.trim().replace("<i>", "").replace("</i>", ""),
                                    "font": "dialogue",
                                })
                            ]
                        }
                    })
                },
            ]
        }
    }
    return {
        "key": "Dialogue",
        "anchor": {"y": "100%"},
        "position": {"x": 0, "y": "100%"},
        "width": 6 * 16,
        "height": 5 * 16,
        "_": [
            // {
            //     "y": 5 * 16,
            //     // "x": -16,
            //     // "y": -34,
            //     // "width": 20,
            //     // "height": 20,
            //     "anchor": {"y": "100%"},
            //     "image": getPortrait(stage.units[stage.dialogue.class] || stage.units["player"]),
            //     // "isFlipped": true,
            // },
            {
                "position": {"x": 8 + 80 - 2, "y": -1*8*(1 + (2 * 2) + 1) - 16 + 96 - 16},
                "_": [
                    NineCut({
                        "width": 44,
                        "height": 6,
                    })
                ]
            },
            // {
            //     "position": {"x": 8 + (8 * 4), "y": -1*8*(7+1) + (8 * 6) - 16 + 96},
            //     "image": require("@frog/source/assets/images/apocalypse-tactics/ui/box/dialogueX.png").default,
            //     "isFlipped": true,
            // },
            {
                "position": {"x": 8 + 80 + 8 + 4 - 2, "y": -1*8*((stage.dialogue.text.split("<br>").length - 1) + (2 * 2) + 1) + 8 - 2 - 16 - 1 + 96 - 16 + 4},
                "_": stage.dialogue.text.split("<br>").filter((text) => text != "").map((text, index) => {
                    return {
                        "position": {
                            "y": index * (11 + 4)
                        },
                        "_": [
                            Text({
                                "text": text.trim().replace("<i>", "").replace("</i>", ""),
                                "font": "dialogue",
                            })
                        ]
                    }
                    // return {
                    //     "position": {
                    //         "y": index * 8
                    //     },
                    //     "_": Text({
                    //         "text": text,
                    //         "font": "dialogue",
                    //     })
                    // }
                })
            },
        ]
    }
}
